export default "__VITE_ASSET__BEM6XfZG__"